/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Radio from 'backbone.radio';
import _ from 'lodash';

import PageableCollection from '@/backbone/PageableCollection';
import ButtonCell from '@/backgrid/ButtonCell';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import GridView from '@/views/GridView';

const InProgressAssessmentsGridView = GridView.extend({
  initialize() {
    this.options.columns = [
      {
        name: 'id',
        label: 'Assessment ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 21,
        editable: false
      },
      {
        name: 'type',
        label: 'Assessment Type',
        cell: StringCell,
        headerCell: 'custom',
        width: 24,
        editable: false
      },
      {
        name: 'status',
        label: 'Assessment Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 26,
        editable: false
      },
      {
        name: 'updatedOn',
        label: 'Last Updated',
        cell: DateCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        direction: 'ascending'
      },
      {
        name: 'openButton',
        label: '',
        width: 10,
        cell: ButtonCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary',
          onClick: this.viewDetails.bind(this),
        }),
        editable: false,
        sortable: false
      }
    ];
    const assessments = this.model.get('data');
    this.padAssessmentIds(assessments);
    this.options.collection = new PageableCollection(assessments, { pageSize: 5 });
    this.options.emptyText = 'No In-Progress Assessments';
  },

  padAssessmentIds(assessments) {
    _.each(assessments, (a) => (a.id = a.id.padStart(5, '0')));
  },
  
  viewDetails(e, model) {
    e.preventDefault();
    if (EXTERNAL) {
      Radio.channel('navigate').request('show:ext:assessment', model.get('id'));
    } else {
      Radio.channel('navigate').request('show:assessment', model.get('id'));
    }
    
  }

});

export default InProgressAssessmentsGridView;
